import { render, staticRenderFns } from "./shopOrderDetail.vue?vue&type=template&id=f4f5f3ea&scoped=true"
import script from "./shopOrderDetail.vue?vue&type=script&lang=js"
export * from "./shopOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./shopOrderDetail.vue?vue&type=style&index=0&id=f4f5f3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f5f3ea",
  null
  
)

export default component.exports